export default {
  release: '16.4',
  date: 'September 2023',
  releasePostUrl: 'https://docs.gitlab.com/releases/16/gitlab-16-4-released/#this-months-notable-contributor-kik',
  contributors: [
    {
      name: 'Kik',
      gitlabUsername: 'oelmekki',
    },
  ],
  writeUp: `Kik has been instrumental in designing and beginning the implementation of ActivityPub support
in GitLab. His original deeply detailed architecture plan has been embraced by our product team
and now lives [as an epic](https://gitlab.com/groups/gitlab-org/-/epics/11247) in the GitLab project.
The [first MR](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/127023) implementing this code was
recently merged, followed by a [documentation addition](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/130960).

As support for this large feature grows, Kik has shown himself to be a personification of the
[GitLab Values](https://handbook.gitlab.com/handbook/values/) of Collaboration, Iteration and Transparency!

Kik has been a part of the GitLab community for many years, logging his [first issue](https://gitlab.com/gitlab-org/gitlab-foss/-/issues/4037#note_4651432)
over 7 years ago. He's chosen to become a bit more active over the last few months. When asked about
his contributions, he stated:

> If there is anything to highlight, it's probably how enabling GitLab is, allowing to see its source code and tinker with it, while being welcoming to contributions, no matter how ambitious they are. :)

He has also chosen to help pioneer our sustainability efforts by choosing to have
[trees planted](https://tree-nation.com/trees/view/5119567) in his name instead of opting for swag. 🌳

Thank you, Kik, for choosing to help build GitLab and being a part of our amazing community! 🙌`,
};
